// redux/slices/notificationSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../services/api";

// ========================
// Async Thunks
// ========================


export const fetchNotifications = createAsyncThunk(
    "notifications/fetch",
    async ({ role, page = 1, limit = 20 }, { rejectWithValue }) => {
        try {

            console.log("n role", role);

            let url = "";

            if (role === "user")
                url = "/notifications/user-notifications";

            else if (role === "servicemen")
                url = "/notifications/all-pandit-notifications";

            else if (role === "admin")
                url = "/notifications/admin-notifications";

            const { data } = await api.get(url, { params: { page, limit } });
            return data;

        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);



// Mark a notification as read
export const markNotificationRead = createAsyncThunk(
    "notifications/markRead",
    async ({ role, id }, { rejectWithValue }) => {
        try {
            let url = `/notifications/`;
            if (role === "user") url += `user/read-by/${id}`;
            else if (role === "servicemen") url += `read-by-servicemen/${id}`;
            else if (role === "admin") url += `readby-admin/${id}`;

            const { data } = await api.put(url);
            return data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// Delete notification (admin only)
export const deleteNotification = createAsyncThunk(
    "notifications/delete",
    async (id, { rejectWithValue }) => {
        try {
            const { data } = await api.delete(`/notifications/delete-notification/${id}`);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// ========================
// Slice
// ========================
const notificationSlice = createSlice({
    name: "notifications",
    initialState: {
        items: [],
        pagination: {},
        loading: false,
        error: null,
    },
    reducers: {
        clearNotifications: (state) => {
            state.items = [];
            state.pagination = {};
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // Fetch
        builder.addCase(fetchNotifications.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchNotifications.fulfilled, (state, action) => {
            state.loading = false;
            state.items = action.payload.data;
            state.pagination = action.payload.pagination || {};
        });
        builder.addCase(fetchNotifications.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error.message;
        });

        // Mark read
        builder.addCase(markNotificationRead.fulfilled, (state, action) => {
            const idx = state.items.findIndex((n) => n._id === action.payload._id);
            if (idx !== -1) state.items[idx].isRead = true;
        });

        // Delete
        builder.addCase(deleteNotification.fulfilled, (state, action) => {
            state.items = state.items.filter((n) => n._id !== action.payload);
        });
    },
});

export const { clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
